/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SmsAuthMethod } from './sms-auth-method';
import {
    SmsAuthMethodFromJSON,
    SmsAuthMethodFromJSONTyped,
    SmsAuthMethodToJSON,
    SmsAuthMethodToJSONTyped,
} from './sms-auth-method';
import type { CustomSmsOAuth } from './custom-sms-o-auth';
import {
    CustomSmsOAuthFromJSON,
    CustomSmsOAuthFromJSONTyped,
    CustomSmsOAuthToJSON,
    CustomSmsOAuthToJSONTyped,
} from './custom-sms-o-auth';
import type { CustomSmsApiKeyAuth } from './custom-sms-api-key-auth';
import {
    CustomSmsApiKeyAuthFromJSON,
    CustomSmsApiKeyAuthFromJSONTyped,
    CustomSmsApiKeyAuthToJSON,
    CustomSmsApiKeyAuthToJSONTyped,
} from './custom-sms-api-key-auth';
import type { CustomSmsBasicAuth } from './custom-sms-basic-auth';
import {
    CustomSmsBasicAuthFromJSON,
    CustomSmsBasicAuthFromJSONTyped,
    CustomSmsBasicAuthToJSON,
    CustomSmsBasicAuthToJSONTyped,
} from './custom-sms-basic-auth';
import type { CustomSmsParameter } from './custom-sms-parameter';
import {
    CustomSmsParameterFromJSON,
    CustomSmsParameterFromJSONTyped,
    CustomSmsParameterToJSON,
    CustomSmsParameterToJSONTyped,
} from './custom-sms-parameter';

/**
 * 
 * @export
 * @interface CustomSmsSettings
 */
export interface CustomSmsSettings {
    /**
     * 
     * @type {string}
     * @memberof CustomSmsSettings
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsSettings
     */
    httpMethod: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSmsSettings
     */
    contentType?: string | null;
    /**
     * 
     * @type {SmsAuthMethod}
     * @memberof CustomSmsSettings
     */
    authMethod?: SmsAuthMethod | null;
    /**
     * 
     * @type {Array<CustomSmsParameter>}
     * @memberof CustomSmsSettings
     */
    parameters: Array<CustomSmsParameter>;
    /**
     * 
     * @type {CustomSmsOAuth}
     * @memberof CustomSmsSettings
     */
    oauth?: CustomSmsOAuth | null;
    /**
     * 
     * @type {CustomSmsBasicAuth}
     * @memberof CustomSmsSettings
     */
    basic?: CustomSmsBasicAuth | null;
    /**
     * 
     * @type {CustomSmsApiKeyAuth}
     * @memberof CustomSmsSettings
     */
    apiKey?: CustomSmsApiKeyAuth | null;
}



/**
 * Check if a given object implements the CustomSmsSettings interface.
 */
export function instanceOfCustomSmsSettings(value: object): value is CustomSmsSettings {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('httpMethod' in value) || value['httpMethod'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function CustomSmsSettingsFromJSON(json: any): CustomSmsSettings {
    return CustomSmsSettingsFromJSONTyped(json, false);
}

export function CustomSmsSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSmsSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'httpMethod': json['http_method'],
        'contentType': json['content_type'] == null ? undefined : json['content_type'],
        'authMethod': json['auth_method'] == null ? undefined : SmsAuthMethodFromJSON(json['auth_method']),
        'parameters': ((json['parameters'] as Array<any>).map(CustomSmsParameterFromJSON)),
        'oauth': json['oauth'] == null ? undefined : CustomSmsOAuthFromJSON(json['oauth']),
        'basic': json['basic'] == null ? undefined : CustomSmsBasicAuthFromJSON(json['basic']),
        'apiKey': json['api_key'] == null ? undefined : CustomSmsApiKeyAuthFromJSON(json['api_key']),
    };
}

export function CustomSmsSettingsToJSON(json: any): CustomSmsSettings {
    return CustomSmsSettingsToJSONTyped(json, false);
}

export function CustomSmsSettingsToJSONTyped(value?: CustomSmsSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'http_method': value['httpMethod'],
        'content_type': value['contentType'],
        'auth_method': SmsAuthMethodToJSON(value['authMethod']),
        'parameters': ((value['parameters'] as Array<any>).map(CustomSmsParameterToJSON)),
        'oauth': CustomSmsOAuthToJSON(value['oauth']),
        'basic': CustomSmsBasicAuthToJSON(value['basic']),
        'api_key': CustomSmsApiKeyAuthToJSON(value['apiKey']),
    };
}

